import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=ce70ec6c&scoped=true&"
import script from "./Footer.vue?vue&type=script&lang=ts&"
export * from "./Footer.vue?vue&type=script&lang=ts&"
import style0 from "./Footer.vue?vue&type=style&index=0&id=ce70ec6c&prod&scoped=true&lang=css&"
import style1 from "./Footer.vue?vue&type=style&index=1&id=ce70ec6c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce70ec6c",
  null
  
)

export default component.exports